<div
  class="loader"
  [class.loader_light]="color === ESpinnerColor.light"
  [class.loader_dark]="color === ESpinnerColor.dark"
></div>
